export const ESIGN_LOGO_KEYS = {
  square: "branding.organizationLogo.square",
  horizontal: "branding.organizationLogo.horizontal",
} as const;
export type EsignLogoVariant = keyof typeof ESIGN_LOGO_KEYS;
export function logoVariantForKey(
  key?: string | null,
): EsignLogoVariant | null {
  if (key === ESIGN_LOGO_KEYS.square) return "square";
  if (key === ESIGN_LOGO_KEYS.horizontal) return "horizontal";
  return null;
}
export function isEsignLogo(field: { dataKey?: string | null }): boolean {
  return logoVariantForKey(field.dataKey) !== null;
}
/** Physical square / horizontal frames; percentages account for the page aspect ratio. */
export function esignLogoFrame(
  variant: EsignLogoVariant,
  pageWidth = 612,
  pageHeight = 792,
) {
  return {
    width: ((variant === "square" ? 48 : 168) / pageWidth) * 100,
    height: (48 / pageHeight) * 100,
  };
}
export function containEsignImage(
  imageWidth: number,
  imageHeight: number,
  box: { x: number; y: number; w: number; h: number },
) {
  if (
    ![imageWidth, imageHeight, box.w, box.h].every(
      (n) => Number.isFinite(n) && n > 0,
    )
  )
    throw new Error("Invalid logo dimensions");
  const scale = Math.min(box.w / imageWidth, box.h / imageHeight);
  const width = imageWidth * scale,
    height = imageHeight * scale;
  return {
    x: box.x + (box.w - width) / 2,
    y: box.y + (box.h - height) / 2,
    width,
    height,
  };
}
